module.exports = __webpack_public_path__ + "img/authenticator_2FA.2f0a88fc.png";